export default {
  PRICE_MGMT_REQUEST: 'APP/PRICE_MGMT/PRICE_MGMT_DETAIL_REQUEST',
  PRICE_MGMT_SUCCESS: 'APP/PRICE_MGMT/PRICE_MGMT_DETAIL_SUCCESS',
  PRICE_MGMT_ERROR: 'APP/PRICE_MGMT/PRICE_MGMT_DETAIL_ERROR',
};
